import customAxios from "@/custom/custom-axios";
import type {
  TaskrptNotifySetting,
  VenuetypeTc
} from "@/types/owner/management/taskrptNotifySetting";

/* 共有一括設定 */
export default class CtrSetting {
  constructor(private readonly _token: any) {}

  /* 共有一括設定の取得 */
  async getSharedSetting() {
    try {
      const res = await customAxios.get(
        `${process.env.APP_API_PATH}/owner/taskrpt-notify-setting`,
        this._token
      );
      return res.data as TaskrptNotifySetting;
    } catch (e) {
      console.error(e);
    }
  }
  /* 共有一括設定の登録、更新 */
  async postSharedSetting(data: TaskrptNotifySetting) {
    try {
      const res = await customAxios.post(
        `${process.env.APP_API_PATH}/owner/taskrpt-notify-setting`,
        data,
        this._token
      );
      return res.data as TaskrptNotifySetting;
    } catch (e) {
      console.error(e);
    }
  }
  /* 共有一括設定内の共有する仕事選択の仕事タイプを削除 */
  async deleteTaskType(
    typeId: string | string[],
    taskrptNotifySetting: TaskrptNotifySetting
  ) {
    //vtcIdを取得
    let delTargetIds: (number | undefined)[] = [];
    if (typeof typeId === "string") {
      const typeIdSplit = typeId.split("-");
      delTargetIds = taskrptNotifySetting.venuetype_tc
        .filter(
          (tc) =>
            tc.venuetype_id === Number(typeIdSplit[0]) &&
            tc.taskcategory_id === Number(typeIdSplit[1])
        )
        .map((vtc: VenuetypeTc) => vtc.id);
    } else {
      delTargetIds = typeId
        .map((id) => {
          const typeIdSplit = id.split("-");
          return taskrptNotifySetting.venuetype_tc
            .filter(
              (tc) =>
                tc.venuetype_id === Number(typeIdSplit[0]) &&
                tc.taskcategory_id === Number(typeIdSplit[1])
            )
            .map((vtc: VenuetypeTc) => vtc.id);
        })
        .flatMap((id) => id);
    }
    //削除リクエスト
    try {
      await Promise.all(
        delTargetIds.map(async (id) => {
          if (id) {
            await customAxios.delete(
              `${process.env.APP_API_PATH}/owner/taskrpt-notify-setting/venuetype_tc/${id}`,
              this._token
            );
          }
        })
      );
    } catch (e) {
      console.error(e);
    }
  }
}
